

import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Route, Switch, Redirect, BrowserRouter as Router } from 'react-router-dom';

import { LoginModal } from "components";

import DashboardSidebar from '../navigation/dashboardSidebar/DashboardSidebar';
import GeneralInvoices from '../invoices/generalInvoices/GeneralInvoices';
// import CompanyInvoices from '../invoices/companyInvoices/CompanyInvoices';
import ClientRegistration from '../clientRegistration/ClientRegistration';
import Logging from "../logging/Logging";
import Home from '../home/Home';
import ActivityLog from '../activityLog/ActivityLog';
import ComActivationRequest from '../comActivationRequest/ComActivationRequest';

import UserList from '../userManagement/userList/UserList';
import UserGroup from '../userManagement/userGroup/UserGroup';
import Permission from '../userManagement/permission/Permission';

import { func_cookie, func_validation, func_url } from 'functions';

import { distributorPortalBaseUrl } from "dataflow/distributorPortal/constants";

import 'assets/scss/distributorPortal/modules/dashboard.scss';
import { authenticationActions, userManagementActions } from 'dataflow/distributorPortal/actions';



function DashboardPresentation(props) {
    const { isLoginModalVisible, userInfo, userPermissions } = props;

    // Check authentication
    useTokenAuthorization(props);

    // User Info
    let isAccessTokenValid = func_validation.isAccessTokenValid("access_token_dp");
    useEffect(() => {
        if ((func_validation.isObjectEmpty(userInfo) ||
                func_validation.isNullUndefined(userInfo)) &&
            func_validation.isRefreshTokenValid("refresh_token_dp") &&
            isAccessTokenValid &&
            props.getUserInfo) {

            props.getUserInfo();
        }
        else if (func_validation.isObjectNotEmpty(userInfo)) {
            let role = func_validation.getObjectPropertyValue(userInfo, "Role");
            if (!func_validation.isStringEqual_caseInsensitive(role, "Dealer")) {
                func_url.historyPushToURL(props, distributorPortalBaseUrl + "login");
            }
        }
    }, [isAccessTokenValid]);

    useEffect(() => {
        let username = func_validation.getObjectPropertyValue(userInfo, "UserName", "");

        if (func_validation.isStringTrimNotEmpty(username) &&
            func_validation.isNullUndefined(userPermissions) &&
            props.getUserGroupPermission) {
            props.getUserGroupPermission(username);
        }
    }, [userInfo]);

    return (
        <Router {...props}>
            <div className={"distributorPortal-dashboard d-flex"}>
                {/* Login Modal having issue removing after successful login */}
                {/* <LoginModal
                    {...props}
                    refreshTokenCookieName={"refresh_token_dp"}
                    isModalVisible={isLoginModalVisible}
                    updateModalVisiblity_parentState={props.toggleLoginModalVisibility}
                    title={"Distributor Portal"}
                /> */}

                {/* Sidebar */}
                <Route path={distributorPortalBaseUrl + "dashboard"} render={(props) => (<DashboardSidebar {...props} />)} />

                <div id={"distributorPortal-dashboard-main flex-fill"} className={"distributorPortal-dashboard-main flex-fill"}>
                    <Switch>
                        {/* <Route path={distributorPortalBaseUrl + "dashboard/invoices"} render={(props) => (<GeneralInvoices {...props} />)} /> */}
                        {/* <Route path={distributorPortalBaseUrl + "dashboard/invoices/general"} render={(props) => (<GeneralInvoices {...props} />)} />
                        <Route path={distributorPortalBaseUrl + "dashboard/invoices/company"} render={(props) => (<CompanyInvoices {...props} />)} /> */}

                        <Route path={distributorPortalBaseUrl + "dashboard/registration/client"} render={(props) => (<ClientRegistration {...props} />)} />

                        {/* {true || func_validation.isUserAccessGranted(props, "Dealer_User_View")?(
                            <Route path={distributorPortalBaseUrl + "dashboard/userManagement/user"} render={(props) => (<UserList {...props} />)} />
                        ):""}
                        {true || func_validation.isUserAccessGranted(props, "Dealer_UserGroup_View")?(
                            <Route path={distributorPortalBaseUrl + "dashboard/userManagement/userGroup"} render={(props) => (<UserGroup {...props} />)} />
                        ):""}
                        {true || func_validation.isUserAccessGranted(props, "Dealer_Permission_View")?(
                            <Route path={distributorPortalBaseUrl + "dashboard/userManagement/permission"} render={(props) => (<Permission {...props} />)} />
                        ):""} */}

                        {func_validation.isUserAccessGranted(props, "Dealer_General_ViewActivityLog")?(
                            <Route path={distributorPortalBaseUrl + "dashboard/activityLog"} render={(props) => (<ActivityLog {...props} />)} />
                        ):""}

                        {func_validation.isUserAccessGranted(props, "Dealer_ComInfo_View")?(
                            <Route path={distributorPortalBaseUrl + "dashboard/comActivation"} render={(props) => (<ComActivationRequest {...props} />)} />
                        ):""}

                        {/* <Route path={distributorPortalBaseUrl + "dashboard/user-logging"} render={(props) => (<Logging {...props} />)} /> */}

                        <Route path={distributorPortalBaseUrl + "dashboard"} render={(props) => (<Home {...props} />)} />

                        <Redirect to={distributorPortalBaseUrl + "dashboard"} />
                    </Switch>

                </div>
            </div>
        </Router>

    );
}

function useTokenAuthorization(props) {
    const [intervalID, setIntervalID] = useState();
    const [isIntervalRemovalRequired, setIsIntervalRemovalRequired] = useState();

    function checkToken() {
        let isFromLoginPage = func_cookie.getCookieValue("in");

        if (!func_validation.isRefreshTokenValid("refresh_token_dp")) {

            if (isFromLoginPage &&
                func_validation.isFunction(props.toggleLoginModalVisibility)) {

                func_url.historyPushToURL(props, distributorPortalBaseUrl + "login");
                // props.toggleLoginModalVisibility(true);
            }
            else {
                setIsIntervalRemovalRequired(true);
                func_url.historyPushToURL(props, distributorPortalBaseUrl + "login");
            }

        }
    }
    useEffect(() => {
        // Check token regular intervals
        setIntervalID(setInterval(checkToken, 500));

        return () => {
            clearInterval(intervalID);
        }
    }, []);
    useEffect(() => {
        if (isIntervalRemovalRequired) clearInterval(intervalID);
    }, [isIntervalRemovalRequired]);
    // useEffect(() => {
    //     // Remove all cookies when hard refresh page
    //     window.addEventListener("beforeunload", () => { func_cookie.removeAllCookies()});
    //     return window.removeEventListener("beforeunload", () => func_cookie.removeAllCookies);
    // }, []);
}

function mapStateToProps(state) {
    const { 
        tokenDetails,
        isLoginModalVisible,

        login_requesting,
        login_status,
        login_errorMsg,
        isLoggedIn,
        
        logout_status,

        getUserInfo_requesting,
        userInfo,

        refreshAccessToken_requesting,
        refreshAccessToken_status
    } = state.distributorPortal_authenticationReducers;

    const { userPermissions } = state.distributorPortal_userManagementReducers;

	return {
        tokenDetails,
        isLoginModalVisible,

        login_requesting,
        login_status,
        login_errorMsg,
        isLoggedIn,

        logout_status,

        getUserInfo_requesting,
        userInfo,

        refreshAccessToken_requesting,
        refreshAccessToken_status,

        userPermissions
    };
}

function mapDispatchToProps(dispatch) {
    return {
        toggleLoginModalVisibility: (isVisible) => { dispatch(authenticationActions.toggleLoginModalVisibility(isVisible)); },
        login: (loginInfoObj) => { dispatch(authenticationActions.login(loginInfoObj)); },
        refreshAccessToken: (tokenInfo) => { dispatch(authenticationActions.refreshAccessToken(tokenInfo)); },

        getUserInfo: () => { dispatch(authenticationActions.getUserInfo()); },
        getUserGroupPermission: (username) => { dispatch(userManagementActions.getUserGroupPermission(username)); }
    };
}

const Dashboard = connect(mapStateToProps, mapDispatchToProps)(DashboardPresentation);

export default Dashboard;